import { render } from "./slider-news-featured.vue?vue&type=template&id=31202b66&scoped=true&lang=html"
import script from "./slider-news-featured.vue?vue&type=script&lang=js"
export * from "./slider-news-featured.vue?vue&type=script&lang=js"

import "./slider-news-featured.vue?vue&type=style&index=0&id=31202b66&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31202b66"]])

export default __exports__